export default "__VITE_ASSET__CHOM1SNB__"